"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-pietro-di-morubio": {
    "924c2a4e": [{
      "hkey": "d9102d04",
      "slug": "san-pietro-di-morubio",
      "name": "San Pietro di Morubio",
      "primary": true,
      "skipSearch": false
    }],
    "borgo": [{
      "hkey": "d9102d04",
      "slug": "san-pietro-di-morubio",
      "name": "San Pietro di Morubio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;